import { scaleToFit } from '../../../Utils/Utils';
import { ButtonColors } from './NineSliceButton';
import { ITextConstructionParameters, TextButton } from './TextButton';

interface IIconTextButtonConstuctorParameters extends ITextConstructionParameters {
    iconId: string;
}

export class IconTextButton extends TextButton {
    constructor({
        width,
        height,
        btnText,
        iconId,
        color = ButtonColors.GREEN,
        outline = 0x3e6c69,
        stroke = 8,
        fontSize = 60,
        lineGap = 60,
    }: IIconTextButtonConstuctorParameters) {
        super({ btnText, width, height, color, outline, stroke, fontSize, lineGap });

        const icon = new PIXI.Sprite(PIXI.utils.TextureCache[iconId]);
        const scale = scaleToFit(
            icon.width,
            icon.height,
            this.nineSlice.width,
            this.nineSlice.height
        );
        icon.scale.set(Math.min(scale, 1));
        icon.anchor.set(0.5, 0.5);
        icon.x = -this.nineSlice.width * 0.5 + icon.width * 0.5 + this.nineSlice.width * 0.05;
        this.textComponent.x += icon.width / 2;
        const textScale = scaleToFit(
            this.textComponent.width,
            this.textComponent.height,
            this.nineSlice.width * 0.4,
            this.nineSlice.height
        );
        this.textComponent.scale.set(Math.min(textScale, 1));
        this.addChild(icon);
    }
}
